import { Builder } from '@builder.io/sdk';
import { USPCards } from './USPCards';

const USPCardsConfig = {
  name: 'USPCards',
  friendlyName: 'USP Cards',
  inputs: [
    {
      name: 'title',
      type: 'string',
      required: true,
    },
    {
      name: 'cards',
      type: 'list',
      required: true,
      min: 3,
      max: 3,
      subFields: [
        {
          name: 'title',
          type: 'string',
        },
        {
          name: 'body',
          type: 'string',
        },
      ],
    },
  ],
};

Builder.registerComponent(USPCards, USPCardsConfig);
